
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import axios from 'axios';
import { Dropdown, /*theme, App,*/ Space, Grid, Typography, Tooltip, Flex, Avatar, Button, Divider, Image, Skeleton } from 'antd';
import { QuestionCircleOutlined, UserOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCirclePlus, faLocationDot, faSignOutAlt, faTools, faUser } from '@fortawesome/free-solid-svg-icons';
import { BACKEND_URL_ACCOUNT } from 'Config/routes';
import { ROUTES } from '@/App/Router/routes';
import { globalSedeSetAction } from 'Redux/globals/selectedSede/actions';
import AlertMessage from '../commonComponents/AlertMessage';
// import { AdminPanel } from '@/features/adminPanel/components/AdminPanel';
import { ConditionalLink } from './ConditionalLink';
import softsegurosLogo from 'Static/images/softseguros-logo.webp';

const { Title, Text } = Typography;
const { useBreakpoint } = Grid;

const MenuSuperior = ({
  user,
  sedes,
  username_user,
  user_sedes,
  userProfileId,
  globalSedeSet,
  globalSelectedSede,
  marcaBlanca,
  style,
}) => {
  // const { modal } = App.useApp();
  // const { token: themeToken } = theme.useToken();
  const screens = useBreakpoint();

  const localStorageGlobalSelectedSedeKey = 'globals--selected-sede';

  useEffect(() => {
    let selectedSede = sedes.find((sede) => user_sedes.includes(sede.id) && sede.id === localStorage.getItem(localStorageGlobalSelectedSedeKey))
    if (!selectedSede) {
      localStorage.removeItem(localStorageGlobalSelectedSedeKey);
      selectedSede = sedes.find((sede) => sede.id === user_sedes[0]);
      if (selectedSede) localStorage.setItem(localStorageGlobalSelectedSedeKey, selectedSede.id);
    }

    globalSedeSet(selectedSede);
  }, []);

  const [error, setError] = useState('');

  const selectionabledSedes = sedes.filter((sede) => user_sedes.includes(sede.id));

  const handleChangeSelectedSede = (newBranch) => {
    localStorage.setItem(localStorageGlobalSelectedSedeKey, newBranch.id);
    globalSedeSet(newBranch);

    // const selectedSede = sedes.find((sede) => sede.id === e.target.value);
    // if (selectedSede) {
    //   localStorage.setItem(localStorageGlobalSelectedSedeKey, selectedSede.id);
    //   globalSedeSet(selectedSede);
    // }
  };

  const handleLogout = () => {
    // Obtiene el token del Local storage
    const token = localStorage.getItem('token');

    axios({
      method: 'GET',
      url: `${BACKEND_URL_ACCOUNT}logout/`,
      headers: {
        'Authorization': `Token ${token}`,
        'content-type': 'application/json'
      },
    })
      .then(() => {
        localStorage.removeItem('token');
        window.location.href = `${process.env.URL_SOFTSEGUROS}`;
      })
      .catch((res) => {
        if (res.response.data.error) {
          setError(res.response.data.error);
        } else {
          setError(res.message);
        }
      });
  };

  const external_session = localStorage.getItem('external_session') === 'true' || false;

  const hasWhiteLabel = !!marcaBlanca?.brand_id; // Cuando tiene marca blanca activa, llega el brand_id

  const branchMenuItems = [
    {
      key: 'branches',
      type: 'group',
      label: (
        <Flex gap={4}>
          <Text>Sedes</Text>
          <Tooltip title='La sede configurada aplica únicamente al crear una cotización. Las existentes conservan la sede con la que fueron creadas, incluso al recotizar.'>
            <QuestionCircleOutlined style={{ cursor: 'help' }} />
          </Tooltip>
        </Flex>
      ),
      children: selectionabledSedes.map((sede) => ({
        key: sede.id,
        label: (
          <Flex gap='small' align='baseline'>
            <Text type='secondary'>
              <FontAwesomeIcon icon={faLocationDot} />
            </Text>
            <Text>{sede.name}</Text>
          </Flex>
        ),
        onClick: () => handleChangeSelectedSede(sede),
      })),
    },
  ];

  const userMenuItems = [
    {
      key: 'userInfo',
      label: (
        <Flex gap={16}>
          <Avatar size='large' icon={<UserOutlined />} />
          <Space size={4} direction='vertical' style={{ flexGrow: 1, width: 1 }}>
            {user.fullName && <Text ellipsis strong>{user.fullName}</Text>}
            {user.username && <Text ellipsis type='secondary'>{user.username}</Text>}
            {user.email && <Text ellipsis type='secondary'>{user.email}</Text>}
            {user.profileName && <Typography.Link ellipsis>{user.profileName}</Typography.Link>}
          </Space>
        </Flex>
      ),
      disabled: true,
      style: { cursor: 'auto' }, // Evita que el cursor cambie a not-allowed por el disabled
    },
    ...(userProfileId === 1 ? [ // Solo se muestra el 'Panel administrativo' si el usuario es gerente
      {
        type: 'divider',
      },
      {
        key: 'adminPanel',
        icon: <FontAwesomeIcon icon={faTools} />,
        label: (
          <Link to={ROUTES.ADMIN_PANEL}>
            Panel administrativo
          </Link>
        ),
      },
    ] : []),
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <FontAwesomeIcon icon={faSignOutAlt} />,
      label: 'Salir',
      onClick: handleLogout,
    },
  ];

  return (<>
    <Flex align='center' gap={8} style={{ height: '100%', ...style }}>
      <Flex flex='1' gap='middle'>
        <ConditionalLink
          to={ROUTES.HOME}
          condition={!external_session}
          style={{ color: '#ffffff' }}
        >
          <Flex align='center' gap={hasWhiteLabel ? 'small' : undefined} style={{ height: '100%' }}>
            <Tooltip title={hasWhiteLabel && !screens.lg ? marcaBlanca?.title_marca_blanca : null} mouseEnterDelay={1}>
              <Image
                src={marcaBlanca?.logo_marca_blanca || softsegurosLogo}
                alt={'Logo'}
                height={51} // 51px es el ancho del logo solicitado para marca blanca
                preview={false}
                style={{
                  objectFit: 'contain',
                  verticalAlign: 'top',
                  width: 'auto',
                  minWidth: 51,
                  maxWidth: '11em',
                }}
                placeholder={<Skeleton.Node active style={{ height: 51, width: 51, verticalAlign: 'top' }} />}
              />
            </Tooltip>
            {screens.lg && ( // Solo se muestra el título si la pantalla es lg o mayor
              <Title level={5} ellipsis={{ rows: 2 }} style={{ margin: 0, color: 'inherit', fontWeight: 700 }}>
                {hasWhiteLabel && marcaBlanca?.title_marca_blanca}
                <Text style={{ color: 'inherit', fontSize: 'inherit', whiteSpace: 'nowrap' }}>
                  <Divider type='vertical' style={{ borderInlineStartWidth: 3, height: '1.4em', backgroundColor: '#ffffff66' }} />
                  <Text strong style={{ color: 'inherit', fontSize: hasWhiteLabel ? undefined : 'inherit' }}>Cotizador autos</Text>
                </Text>
              </Title>
            )}
          </Flex>
        </ConditionalLink>
        {!external_session && (
          <Tooltip title={screens.sm ? null : 'Nueva cotización'} mouseEnterDelay={0.5}>
            <Link to={ROUTES.QUOTATIONS.CREATE}>
              <Button
                type='primary'
                icon={<FontAwesomeIcon icon={faFileCirclePlus} />}
                style={{ border: '1px solid #ffffff' }}
              >
                {screens.sm && 'Nueva cotización'}
              </Button>
            </Link>
          </Tooltip>
        )}
      </Flex>
      {!external_session && (
        <Flex gap='small'>
          <Dropdown
            trigger={['click']}
            placement='bottomRight'
            menu={{
              selectable: true,
              defaultSelectedKeys: [globalSelectedSede?.id],
              items: branchMenuItems,
            }}
            overlayStyle={{ width: '20em' }}
          >
            <Button
              type='primary'
              icon={<FontAwesomeIcon icon={faLocationDot} />}
              style={{ justifyContent: 'end', maxWidth: screens.xl ? '20em' : '10em' }}
            >
              <Text ellipsis style={{ color: 'inherit' }}>{globalSelectedSede?.name ?? 'Seleccionar sede'}</Text>
            </Button>
          </Dropdown>
          <Dropdown
            trigger={['click']}
            menu={{ items: userMenuItems }}
            overlayStyle={{ width: '20em' }}
          >
            <Button
              type='primary'
              icon={<FontAwesomeIcon icon={faUser} />}
              {...(!screens.md && {
                shape: 'circle',
                icon: <Avatar icon={<UserOutlined />} style={{ display: 'block' }} />,
              })}
            >
              {screens.md ? username_user : undefined}
            </Button>
          </Dropdown>
        </Flex>
      )}
    </Flex>
    {!!error && (
      <AlertMessage
        title='Error al cerrar sesión'
        type='error'
        message={error}
        closable
      />
    )}
  </>);
};

MenuSuperior.propTypes = {};


const actions = {
  globalSedeSet: globalSedeSetAction,
};
const mapStateToProps = (state) => ({
  user: state.initialData.user,
  sedes: state.initialData.sedes,
  username_user: state.initialData.user?.username,
  user_sedes: state.initialData.user?.sedes,
  userProfileId: state.initialData.user?.perfil,

  globalSelectedSede: state.globals.selected_sede,
  marcaBlanca: state.initialData.marcablanca,
});
export default connect(mapStateToProps, actions)(MenuSuperior);
